import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=2573dc69&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=2573dc69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2573dc69",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2573dc69')) {
      api.createRecord('2573dc69', component.options)
    } else {
      api.reload('2573dc69', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=2573dc69&scoped=true&", function () {
      api.rerender('2573dc69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2D7JXo05vHXns/JS/comp/PopupDialog.vue"
export default component.exports